import { render, staticRenderFns } from "./PickupWay.vue?vue&type=template&id=bdbc6adc&scoped=true&"
import script from "./PickupWay.vue?vue&type=script&lang=ts&"
export * from "./PickupWay.vue?vue&type=script&lang=ts&"
import style0 from "./PickupWay.vue?vue&type=style&index=0&id=bdbc6adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbc6adc",
  null
  
)

export default component.exports